import{useIsomorphicLayoutEffect as e}from"./use-isomorphic-layout-effect.js";const t=(t,o)=>{e((()=>(document.addEventListener(t,o,{passive:!0}),()=>{document.removeEventListener(t,o)})),[o])};export{t as useDocumentEventHandler};
